<div class="event-wrapper">
  <div class="event-container item">
    <evrideo-calendar-expandable-red-line-indicator></evrideo-calendar-expandable-red-line-indicator>
    <div
      class="visibility-icon"
      (click)="toggleSecEvent(show, properties.id)"
      [inlineSVG]="
        properties.enabled
          ? '../../assets/icons/eye-icon.svg'
          : '../../assets/icons/eye-disabled.svg'
      "
    ></div>
    <evrideo-calendar-expandable-progress-bar
      [eventData]="properties"
      class="a"
    ></evrideo-calendar-expandable-progress-bar>
    <div class="item-title-container z">
      <div
        class="event-icon"
        inlineSVG="../../assets/icons/floating-media.svg"
      ></div>
      <span class="item-title-text">Floating Media</span>
    </div>
    <div class="item-name z">{{ properties.name }}</div>
    <div class="start-time-container z">
      <evrideo-calendar-expandable-editable-time
        [eventData]="floatingMediaData"
        [showId]="show.id"
        [timeType]="'StartTime'"
        [time]="formatTime(properties.startTime)"
        [editLocked]="true"
      ></evrideo-calendar-expandable-editable-time>
    </div>
    <div class="end-time-container z">
      <evrideo-calendar-expandable-editable-time
        [eventData]="floatingMediaData"
        [showId]="show.id"
        [timeType]="'EndTime'"
        [time]="formatTime(properties.endTime)"
        [editLocked]="true"
      ></evrideo-calendar-expandable-editable-time>
    </div>
    <div class="duration-time-container z">
      <evrideo-calendar-expandable-editable-time
        [eventData]="floatingMediaData"
        [showId]="show.id"
        [timeType]="'Duration'"
        [time]="formatDuration(properties.duration)"
        [editLocked]="true"
      ></evrideo-calendar-expandable-editable-time>
    </div>
    <div class="offset-time-container z">
      <evrideo-calendar-expandable-editable-time
        [eventData]="floatingMediaData"
        [showId]="show.id"
        [timeType]="'Offset'"
        [time]="formatDuration(properties.offset)"
        [editLocked]="true"
      ></evrideo-calendar-expandable-editable-time>
    </div>
    <div class="right-items z">
      <div *ngIf="false" class="instance-item z">Location Editor</div>
      <div
        *ngIf="false"
        (click)="deleteEvent()"
        class="trash-icon"
        inlineSVG="../../assets/icons/trash-enabled.svg"
      ></div>
    </div>
  </div>
</div>
